import type { DocumentReviewDetailOutput } from '@/app/document-review/use-document-review'

export function latestRun(detail: DocumentReviewDetailOutput): number {
  return Math.max(detail.run, ...detail.runs.map((one) => one.run))
}

export function newerRunOf(detail: DocumentReviewDetailOutput): number | null {
  const newer = detail.runs.filter((one) => one.run > detail.run).map((one) => one.run)
  return newer.length === 0 ? null : Math.max(...newer)
}
